import { render, staticRenderFns } from "@/style-guide/partials/selectTag/select.tag.pug?vue&type=template&id=6966541d&scoped=true&lang=pug&external"
import script from "./select.tag.vue?vue&type=script&lang=ts"
export * from "./select.tag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966541d",
  null
  
)

export default component.exports